function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var BackArrow = function BackArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillRule: "evenodd",
    d: "M13.629 3.705a1 1 0 0 0-1.418-1.41l-9 9.05a1 1 0 0 0 .004 1.414l9 8.95a1 1 0 0 0 1.41-1.418L6.293 13H20.08a1 1 0 1 0 0-2H6.374z",
    clipRule: "evenodd"
  }));
};
export default BackArrow;